// extracted by mini-css-extract-plugin
export default {"container":"NewLandingPageCard_container__7AOy1","toprow":"NewLandingPageCard_toprow__oVxXD","toprowleft":"NewLandingPageCard_toprowleft__iYl4b"};